import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import IconFilter from 'components/icons/iconFilter2';
import { colorGray, colorWhite } from 'styles/layout/colors';
import MobileOnly from 'components/consumer/MobileOnly';
const MobileProductFiltersButton = t0 => {
  const $ = _c(19);
  const {
    onClick,
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.filter(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeFilterCount = t1.length;
  const hasActiveFilters = activeFilterCount > 0;
  const t2 = !hasActiveFilters;
  let t3;
  if ($[2] !== hasActiveFilters || $[3] !== t2) {
    t3 = classNames("md:hidden text-sm font-bold items-center rounded-sm flex justify-center mr-[6px] p-3 border-[1px] max-h-12", {
      "bg-brand border-brand text-white": hasActiveFilters,
      "bg-white border-gray-light3 text-gray": t2
    });
    $[2] = hasActiveFilters;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = hasActiveFilters ? colorWhite : colorGray;
  let t5;
  if ($[5] !== t4) {
    t5 = <IconFilter className="mr-[6px]" color={t4} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = !hasActiveFilters;
  let t7;
  if ($[7] !== hasActiveFilters || $[8] !== t6) {
    t7 = classNames("h-full", {
      "text-gray": t6,
      "text-white": hasActiveFilters
    });
    $[7] = hasActiveFilters;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span>Filters</span>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = activeFilterCount > 0 && ` (${activeFilterCount})`;
  let t10;
  if ($[11] !== t7 || $[12] !== t9) {
    t10 = <span className={t7}>{t8}{t9}</span>;
    $[11] = t7;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== onClick || $[15] !== t10 || $[16] !== t3 || $[17] !== t5) {
    t11 = <MobileOnly><button type="button" className={t3} onClick={onClick}>{t5}{t10}</button></MobileOnly>;
    $[14] = onClick;
    $[15] = t10;
    $[16] = t3;
    $[17] = t5;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};
export default MobileProductFiltersButton;
function _temp(item) {
  return item.isRefined;
}